import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import { Box } from 'rebass/styled-components';
import theme from 'styled-theming';

const backgroundColor = theme('mode', {
  light: (props: any) => props.theme.colors.periwinkleLighter,
  dark: (props: any) => props.theme.colors.whiteGrey,
});

const color = theme('mode', {
  light: (props: any) => props.theme.colors.periwinkleDarker,
  dark: (props: any) => props.theme.colors.periwinkleDarker,
});

export enum InputAdornmentSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export interface InputAdornmentProps {
  children: React.ReactNode;
  side?: InputAdornmentSide;
}

const StyledAdornment = styled(Box)`
  background-color: ${backgroundColor};
  color: ${color};
  font-weight: 700;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 16px;
  height: 100%;
  width: 100%;
`;

const InputAdornment: FunctionComponent<
InputAdornmentProps> = ({ children, side = InputAdornmentSide.LEFT }: InputAdornmentProps) => (
  <StyledAdornment
    sx={{
      borderRadius: side === InputAdornmentSide.LEFT ? '4px 0px 0px 4px' : '0px 4px 4px 0px',
    }}
  >
    {children}
  </StyledAdornment>
);

export default InputAdornment;
